import { Container, Row, Col } from "react-bootstrap";
// import { MailchimpForm } from "./MailchimpForm";
import logo from "../assets/img/logo.png";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";
import navIcon4 from "../assets/img/nav-icon4.svg";

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          {/* <MailchimpForm /> */}
          <Col size={12} sm={6}>
            <img src={logo} alt="Logo" />
            <Row className="align-items-center">
              <a href="https://ko-fi.com/frisrsyd"> <img align="left" src="https://cdn.ko-fi.com/cdn/kofi3.png?v=3" height="50" width="210" alt="frisrsyd" /></a>
            </Row>
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a href="https://linkedin.com/in/frisrsyd" target="_blank" rel="noreferrer"><img src={navIcon1} alt="LinkedIn Icon" /></a>
              <a href="https://github.com/frisrsyd" target="_blank" rel="noreferrer"><img src={navIcon2} alt="Github Icon" /></a>
              <a href="https://instagram.com/frisrsyd" target="_blank" rel="noreferrer"><img src={navIcon3} alt="Instagram Icon" /></a>
              <a href="https://ko-fi.com/frisrsyd" target="_blank" rel="noreferrer"><img src={navIcon4} alt="Instagram Icon" /> </a>
            </div>
            <p>Copyright &copy;{currentYear} by frisrsyd. All Rights Reserved</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
